import React from 'react'

import { Container, Row, Col } from '../components/Bootstrap'
import Card from '../components/Card'
import ColumnList from '../components/ColumnList'
import Footnote from '../components/Footnote'
import Hero from '../components/Hero'
import Layout from '../components/Layout'
import Panel from '../components/Panel'

import { colours } from '../theme';
import { bold } from '../styles'

import consumers from '../images/consumers.svg'
import partners from '../images/partners.svg'
import stakeholders from '../images/stakeholders.svg'

const ResultsPage = () => (
  <Layout>
    <Hero>
      <h1>Survey Results</h1>
      <p className={bold}>Select a survey demographic to view the results.</p>
    </Hero>
    <Container>
      <Row className="justify-content-center">
        <Col md="3" className="d-flex">
          <Card to="/all/1/" image={stakeholders}>
            All Respondents<sup>*</sup>
          </Card>
        </Col>
        <Col md="3" className="d-flex">
          <Card to="/consumers/1" image={consumers}>
            Consumers
          </Card>
        </Col>
        <Col md="3" className="d-flex">
          <Card to="/partners/1" image={partners}>
            Community Partners
          </Card>
        </Col>
      </Row>
    </Container>
	<Footnote>
		*Includes board members, volunteers, staff, community partners, consumers, family members and other stakeholders.
	</Footnote>
    <Panel colour={colours.primary}>
      <Container>
        <h2>Early findings from 65 surveys</h2>
		<ColumnList>
			<li>34%  respondents were consumers (including families and volunteers); 29% community partners; 19% other stakeholders (non-member; members); 13% staff members and 5% board members.</li>
			<li>Purpose of CILT: Advocacy; Resource to the community; Promotion of Independent Living through Programs as main themes; to reduce isolation of people with disabilities through peer supports and building confidence.</li>
			<li>Main focus of CILT*: Core Programs (89%), Direct Funding (68%), Attendant Services Application Centre (43%), Administering PSW Training (27%)*multiple answers </li>
			<li>45% respondents have been involved with CILT for over 10  years; 19%  respondents for over 5 to 10 years; 19% respondents for over 1 to 5 years; and 14% for less than 1 year.</li>
			<li>Five  most important programs are Service Navigation, Peer Support, Independent Living Skills, Direct Funding and ASAC.</li>
			<li>Improvements on Community Engagement, Program development, Resource Development and Communications and Branding (ranking) </li>
        </ColumnList>
      </Container>
    </Panel>
  </Layout>
)

export default ResultsPage
